import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getAllCompanyModuleMappings } from '../../services/user.service';
import * as CryptoJS from "crypto-js";
import Box from '@mui/material/Box';
import { DataGrid, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';

export default function CompanyModuleMappingList() {
    const [mappings, setMappings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchMappings();
    }, []);

    const fetchMappings = () => {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = { 'token': EncryptData };
        setLoading(true);

        getAllCompanyModuleMappings(oData).then(res => {
            if (res.data.data) {
                setMappings(res.data.data);
            }
            setLoading(false);
        }).catch(err => {
            setError('Failed to fetch mappings');
            setLoading(false);
        });
    };

    const columns = [
        { field: "company_name", headerName: "Company Name", width: 250 },
        { field: "module_id", headerName: "Web Modules", width: 300 },
        { field: "app_module_id", headerName: "App Modules", width: 300 },
        {
            field: "created_at",
            headerName: "Created Date",
            width: 150,
            renderCell: (params) => (
                <p>{params.row.created_at ? new Date(params.row.created_at).toLocaleDateString() : '-'}</p>
            )
        },
        {
            field: 'actions', headerName: 'Actions', width: 120, renderCell: (params) => {
                let EncryptID = CryptoJS.AES.encrypt(JSON.stringify({
                    'company_id': params.row.company_id,
                }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
                return (
                    <span>
                        <Link to={`/company-module-mapping?compid=${EncryptID}`} className="p-2">
                            <button type="button" className="btn btn-primary btn-sm">
                                <i className="bi bi-pencil"></i>
                            </button>
                        </Link>
                    </span>
                );
            }
        }
    ];

    const CustomToolbar = () => (
        <GridToolbarContainer>
            <GridToolbarExport />
        </GridToolbarContainer>
    );

    return (
        <div className="container1">
            <div className="row mb-4">
                <div className="col-md-6">
                    <h5>Company Module Mapping List</h5>
                </div>
                <div className="col text-end">
                    <Link to="/company-module-mapping" className="btn btn-primary btn-sm">Add New Mapping</Link>
                </div>
            </div>

            {error && <div className="alert alert-danger">{error}</div>}

            {loading ? (
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <DataGrid
                    components={{
                        Toolbar: CustomToolbar,
                    }}
                    rows={mappings}
                    getRowId={(row) => row.id}
                    columns={columns}
                    pageSize={50}
                    autoHeight
                    rowsPerPageOptions={[50]}
                />
            )}
        </div>
    );
}
